import React, { Component } from 'react'

class GenericMsgErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: null, errorInfo: null }
  }
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ERROR IN display')
    this.setState({ hasError: true, errorInfo: errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <span class="text-danger">{this.props.msg ? this.props.msg : 'Something went wrong!'}</span>
        </div>
      )
    }
    return this.props.children
  }
}

export default GenericMsgErrorBoundary
